'use strict';
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const _GoogleOutlined = _interopRequireDefault(require('./lib/icons/GoogleOutlined'));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

const _default = _GoogleOutlined;
exports.default = _default;
module.exports = _default;